import SiderBarMenu from "./SideBarMenu";
import SidebarLayout from "./SideBarLayout";

const ChatSideBar = ({ isFullScreen, isMenuOpen, setIsMenuOpen, handleNewChat }) => {

  return (
    <>
      <SiderBarMenu
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
      />
      <SidebarLayout
        isFullScreen={isFullScreen}
        handleNewChat={handleNewChat}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
      />
    </>
  );
};

export default ChatSideBar;